/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { getFormatValues } from '../../../../lib/utils';

import styles from '../../../../../styles/guest/sections/content/description.module.scss';

const propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    active: false,
    className: null,
};

const Description = ({ active, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.active]: active,
            },
        ])}
    >
        <div className={styles.title}>
            <h2>
                <FormattedMessage
                    defaultMessage="Make an impression{break}effortlessly"
                    description="Guest content - fold title"
                    values={getFormatValues()}
                />
            </h2>
        </div>
        <div className={styles.description}>
            <div className={styles.descriptionInner}>
                {/* <p>
                    <FormattedMessage
                        defaultMessage="By choosing <strong>Micromag</strong> to tell your stories, you’re opting for a memorable and intuitive content{nbsp}experience."
                        description="Guest content - fold description 1"
                        values={getFormatValues()}
                    />
                </p> */}
                <p>
                    <FormattedMessage
                        defaultMessage="A turnkey solution that is mobile optimized, built to eliminate technological restrictions and make space for your narrative goals and your{nbsp}imagination."
                        description="Guest content - fold description 2"
                        values={getFormatValues()}
                    />
                </p>
                <p>
                    <FormattedMessage
                        defaultMessage="Through video, text and images,{nbsp}without a single line of code."
                        description="Guest content - fold description 3"
                        values={getFormatValues()}
                    />
                </p>
            </div>
        </div>
    </div>
);

Description.propTypes = propTypes;
Description.defaultProps = defaultProps;

export default Description;
